import React from 'react';
import PropTypes from 'prop-types';
import StyledTextField from '../common/StyledTextField';
import PasswordInput from '../PasswordInput';

function SignInForm({
  signInPath,
  csrfToken,
  invitedEmail,
  submitId,
  newPasswordPath,
  showRegisterLinks,
  employerRegistrationPath,
  consultantRegistrationPath,
  children,
}) {
  return (
    <div className="signin">
      <form method="POST" action={signInPath} id="sign-in-form">
        <input type="hidden" name="authenticity_token" value={csrfToken} />
        {children}

        <StyledTextField
          id="email"
          className="form-control fs-hide validate"
          name="user[email]"
          label="Email"
          type="email"
          defaultValue={invitedEmail}
          margin="normal"
          required
        />

        <PasswordInput
          errors={false}
          title="Password"
          tabIndex="0"
          type="sign-in"
        />

        {newPasswordPath
      && (
      <div className="row small-text">
        <div className="col-xs-12 forgot-password">
          <a href={newPasswordPath}>Don&#39;t have your password?</a>
        </div>
      </div>
      )}

        <input
          type="submit"
          className="btn btn-primary full-width sign-in-button"
          id={submitId}
          value="Sign in"
          tabIndex="0"
        />

        {showRegisterLinks
      && (
      <div className="register-links">
        Don&#39;t have an account?
        <a href={employerRegistrationPath}>Sign Up as an Employer</a>
        or
        <a href={consultantRegistrationPath}>Join as a Consultant</a>
      </div>
      )}
      </form>
    </div>
  );
}

SignInForm.propTypes = {
  signInPath: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  invitedEmail: PropTypes.string,
  newPasswordPath: PropTypes.string,
  showRegisterLinks: PropTypes.bool,
  employerRegistrationPath: PropTypes.string,
  consultantRegistrationPath: PropTypes.string,
  submitId: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

SignInForm.defaultProps = {
  invitedEmail: null,
  newPasswordPath: null,
  showRegisterLinks: false,
  employerRegistrationPath: null,
  consultantRegistrationPath: null,
  submitId: 'sign-in',
  children: null,
};

export default SignInForm;
